import { useQuery } from "@tanstack/react-query";
import {
  getTelegramLinkStatus,
  getTwoFactorStatus,
} from "@/api/twoFactor";

export enum TwoFactorQueryKeys {
  Status = "twoFactorStatus",
  TelegramLinkStatus = "telegramLinkStatus",
}

export const useTwoFactorStatus = () => {
  return useQuery({
    queryKey: [TwoFactorQueryKeys.Status],
    queryFn: getTwoFactorStatus,
  });
};

export const useTelegramLinkStatusPolling = (enabled: boolean) => {
  return useQuery({
    queryKey: [TwoFactorQueryKeys.TelegramLinkStatus],
    queryFn: getTelegramLinkStatus,
    enabled,
    refetchInterval: enabled ? 2000 : false,
  });
};
